import {
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
    ContextMenuItem,
} from '@cad-arc';
import { useAddAssignedUnitsApi } from './use-add-assiged-units-api';
import { AssignAsBackupToSubmenuView, UnitContextMenuClickParams } from '@mark43/cad-api';

export function AssignAsBackupToSubmenu({
    assignAsBackupToSubmenuView,
    clickParams,
}: {
    assignAsBackupToSubmenuView: AssignAsBackupToSubmenuView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const addAssignedUnits = useAddAssignedUnitsApi();

    return assignAsBackupToSubmenuView.isVisible ? (
        <ContextMenuSub>
            <ContextMenuSubTrigger
                data-pendo-id="menu-item-assign-as-backup-to"
                isDisabled={!assignAsBackupToSubmenuView.isEnabled}
            >
                {assignAsBackupToSubmenuView.label}
            </ContextMenuSubTrigger>
            <ContextMenuSubContent style={{ maxHeight: '100vh' }}>
                {assignAsBackupToSubmenuView.assignAsBackupToView.assignedCallSignOptions.map(
                    (callSignOption) => (
                        <ContextMenuItem
                            key={callSignOption.value}
                            onSelect={() => {
                                addAssignedUnits({
                                    eventId: callSignOption.eventId,
                                    unitIds: [clickParams.unitId],
                                });
                            }}
                        >
                            {callSignOption.label}
                        </ContextMenuItem>
                    )
                )}
            </ContextMenuSubContent>
        </ContextMenuSub>
    ) : (
        <></>
    );
}
